import { useState } from 'react'
import { supabase } from '../supabaseClient'
import {
  WaitlistContainer,
  WaitlistContent,
  WaitlistTitle,
  WaitlistSubtitle,
  WaitlistForm,
  WaitlistInput,
  WaitlistButton,
  WaitlistMessage,
  CloseWaitlist
} from './styles'

export default function Waitlist({ isOpen, onClose }) {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!email) {
      setMessage('Please enter your email')
      return
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      setMessage('Please enter a valid email address')
      return
    }

    setIsSubmitting(true)
    setMessage('')

    try {
      // Insert data into Supabase
      const { data, error } = await supabase
        .from('waitlist')
        .insert([
          {
            email: email.trim().toLowerCase()
          }
        ])

      if (error) {
        // Check if it's a duplicate email error
        if (error.code === '23505') {
          setMessage('This email is already on the waitlist!')
        } else {
          console.error('Error:', error)
          setMessage('Something went wrong. Please try again.')
        }
        setIsSubmitting(false)
        return
      }

      setMessage('Thanks for joining! We\'ll be in touch soon.')
      setEmail('')
      setIsSubmitting(false)

      // Auto close after 2 seconds
      setTimeout(() => {
        onClose()
        setMessage('')
      }, 2000)
    } catch (error) {
      console.error('Error submitting form:', error)
      setMessage('Something went wrong. Please try again.')
      setIsSubmitting(false)
    }
  }

  if (!isOpen) return null

  return (
    <WaitlistContainer onClick={onClose}>
      <WaitlistContent onClick={(e) => e.stopPropagation()}>
        <CloseWaitlist onClick={onClose}>×</CloseWaitlist>

        <WaitlistTitle>Join the Waitlist</WaitlistTitle>
        <WaitlistSubtitle>
          Be the first to know when we launch
        </WaitlistSubtitle>

        <WaitlistForm onSubmit={handleSubmit}>
          <WaitlistInput
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isSubmitting}
            autoFocus
          />
          <WaitlistButton type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Joining...' : 'Join Waitlist'}
          </WaitlistButton>
        </WaitlistForm>

        {message && <WaitlistMessage>{message}</WaitlistMessage>}
      </WaitlistContent>
    </WaitlistContainer>
  )
}
